import "./scss/main.scss";

import { Filters } from "./js/filters";
import $ from "jquery";
import datepickerFactory from 'jquery-datepicker';
datepickerFactory($);
window.$ = window.jQuery = $;

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'lazysizes';
import { getLogo } from "./js/logos";

$(function () {

	var form = $('.search_ajaxss');

	var filters = new Filters({
		formURL: form.attr('action'),
		contentArea: $('.jobs_list'),
		form: form,
		cookieSaveEnabled: false,
		enabled: $("body").hasClass("vacancies"),
		enableTypetimer: false,
		chosen: true,
		bbq: false,
		visibleClassifications: [],
		scrollToTop: false,
		checkbox: true,
	});

	filters.enableJPages('.jobs-nav', 'jobs_list', 12);
	filters.reload();
	filters.readSearchHash();

	if ($('[name="p_published_to"').val() === 'WWW') {
		window.external = true;
	}

	$('.displayModesList a').on('click', function () {
		filters.reload(true);
	});

	$('.box-filter').removeClass('is_open');
	$('.box-filter-header').on('click', function () {
		$(this).parent().toggleClass('is_open');
	});

	$('.toggle-menu').on('click', function () {
		$('.navbar-mobile').toggleClass('active');
	});


	if ($('body').hasClass('vacancy')) {
		let $attachments = $('.job_classifications')
			.find('.attachments a')
			.addClass('button button--primary');

		$attachments.appendTo('.links');

		$('.links').insertBefore('.menu');
		$('.job_classifications').insertBefore('.job_summary');
	}

	HS.onFormInit = () => {
		$('#hs_popup')
			.find('select')
			.parent('.form-group')
			.addClass('form-select-container');
	}

	$(document).on('scroll', () => {
		if ($(document).scrollTop() >= 60) {
			$('.header-menu-sticky').addClass('sticky--on');
		} else if ($(document).scrollTop() >= 0) {
			$('.header-menu-sticky').removeClass('sticky--on');
		}
		if ($('.search-form-area').hasClass("active")) {
			$('.search-form-area').removeClass('active');
		}
		if ($(document).scrollTop() > 150) {
			$('.scroll-to-up').addClass("visible");
		} else {
			$('.scroll-to-up').removeClass("visible");
		}
	});

	$('.scroll-to-up').on('click', () => {
		$("html, body").animate({
			scrollTop: 0
		}, 800);
		return false;
	});

	let root = document.documentElement;
	let filterCount = document.querySelectorAll('#p_text, [name="p_category_code_arr"]').length;

	const COLUMNS = 4;
	let span = COLUMNS - (filterCount % COLUMNS)

	root.style.setProperty('--search-btn-span', span);

	$(".x_company_logo, .x_advert_brand, .x_business_area_logo, .x_eu_logo_file").css("display", "none");

	const logoName = $("#business_area_logo").text().trim();
	const euLogo = $("#eu_logo_file").text().trim();

	$("#main-content .menu").append(getLogo(logoName));
	if (euLogo) {
		$("#main-content .menu").append(getLogo(euLogo));
	}
});
